import { useNavigate } from "react-router-dom";
import Button from "../../components/Shared/Button";
import { AlertTriangle, Home, ArrowLeft } from "lucide-react";

const DashboardError = () => {
  const navigate = useNavigate();

  return (
    <div className="py-7 min-h-screen flex items-center justify-center">
      <div className="p-8 rounded-xl bg-white border-black/15 shadow max-w-2xl w-full">
        <div className="flex flex-col items-center text-center">
          {/* Error Icon */}
          <div className="mb-6 flex items-center justify-center w-20 h-20 rounded-full bg-red-100">
            <AlertTriangle className="w-10 h-10 text-red-600" />
          </div>

          {/* Error Message */}
          <h1 className="text-burntBlack font-bold text-4xl mb-4">
            Oops! Something went wrong
          </h1>
          <p className="text-gray-600 text-lg mb-2">
            We're sorry, but something unexpected happened.
          </p>
          <p className="text-gray-500 text-sm mb-8">
            The page you're looking for doesn't exist or an error occurred while loading it.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <Button
              onClick={() => navigate(-1)}
              className="!h-12 !px-6 !text-sm font-bold rounded-md !bg-gray-600 hover:!bg-gray-700 flex items-center justify-center gap-2"
              variant="primary"
            >
              <ArrowLeft size={18} />
              Go Back
            </Button>
            <Button
              onClick={() => navigate("/dashboard/students")}
              className="!h-12 !px-6 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary flex items-center justify-center gap-2"
              variant="primary"
            >
              <Home size={18} />
              Go to Dashboard
            </Button>
          </div>

          {/* Additional Help */}
          <div className="mt-8 pt-6 border-t border-gray-200 w-full">
            <p className="text-sm text-gray-500">
              If this problem persists, please contact the system administrator.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardError;

